import React from 'react';
import {
    Container,
    Box,
    Typography,
    Paper,
    Grid,
    Card,
    Button,
} from '@mui/material';
import {
    Diamond as DiamondIcon,
    QrCode as QrCodeIcon,
    CardGiftcard as GiftIcon,
    Star as StarIcon,
    TrendingUp as TrendingUpIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const HomePage = () => {
    const navigate = useNavigate();

    const features = [
        {
            icon: <DiamondIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
            title: 'Khách Hàng Ưu Đãi',
            description: 'Chương trình dành riêng cho khách hàng thân thiết với nhiều ưu đãi đặc biệt',
        },
        {
            icon: <GiftIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
            title: 'Tích Điểm Thưởng',
            description: 'Tích lũy điểm với mỗi giao dịch và đổi quà tặng hấp dẫn',
        },
        {
            icon: <StarIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
            title: 'Ưu Tiên Phục Vụ',
            description: 'Được ưu tiên phục vụ và hỗ trợ tận tình từ đội ngũ nhân viên',
        },
        {
            icon: <TrendingUpIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
            title: 'Giảm Giá Đặc Biệt',
            description: 'Nhận giảm giá độc quyền cho các sản phẩm và dịch vụ',
        },
    ];

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                bgcolor: 'background.default',
            }}
        >
            <Container maxWidth="lg" sx={{ flex: 1, py: 6 }}>
                {/* Hero Section */}
                <Paper
                    elevation={3}
                    sx={{
                        p: { xs: 4, sm: 6 },
                        borderRadius: 4,
                        mb: 6,
                        background: 'linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%)',
                        color: 'white',
                        textAlign: 'center',
                    }}
                >
                    <DiamondIcon sx={{ fontSize: 80, mb: 2, opacity: 0.9 }} />
                    <Typography variant="h3" gutterBottom sx={{ fontWeight: 700, mb: 2 }}>
                        App Loyalty Đại Minh Phát
                    </Typography>
                    <Typography variant="h6" sx={{ mb: 4, opacity: 0.95, fontWeight: 400 }}>
                        Chương trình khách hàng thân thiết dành cho nhân viên sân bay
                    </Typography>
                    <Button
                        variant="contained"
                        size="large"
                        onClick={() => navigate('/qrcode')}
                        startIcon={<QrCodeIcon />}
                        sx={{
                            bgcolor: 'white',
                            color: 'primary.main',
                            px: 4,
                            py: 1.5,
                            fontSize: '1.1rem',
                            '&:hover': {
                                bgcolor: 'grey.100',
                            },
                        }}
                    >
                        Tạo QR Đăng Ký
                    </Button>
                </Paper>

                {/* Features Section */}
                <Box sx={{ mb: 6 }}>
                    <Typography
                        variant="h4"
                        align="center"
                        gutterBottom
                        sx={{ fontWeight: 600, mb: 4, color: 'primary.main' }}
                    >
                        Quyền Lợi Của Bạn
                    </Typography>
                    <Grid container spacing={3}>
                        {features.map((feature, index) => (
                            <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
                                <Card
                                    elevation={2}
                                    sx={{
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                        p: 3,
                                        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                        '&:hover': {
                                            transform: 'translateY(-8px)',
                                            boxShadow: '0 8px 24px rgba(46, 125, 50, 0.2)',
                                        },
                                    }}
                                >
                                    <Box sx={{ mb: 2 }}>{feature.icon}</Box>
                                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                                        {feature.title}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {feature.description}
                                    </Typography>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>

                {/* CTA Section */}
                <Paper
                    elevation={2}
                    sx={{
                        p: 4,
                        borderRadius: 4,
                        textAlign: 'center',
                        bgcolor: 'grey.50',
                    }}
                >
                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
                        Bắt Đầu Ngay Hôm Nay
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                        Tham gia chương trình khách hàng ưu đãi và nhận ngay những quyền lợi đặc biệt
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
                        <Button
                            variant="contained"
                            size="large"
                            onClick={() => navigate('/qrcode')}
                            sx={{ px: 4 }}
                        >
                            Tạo QR Code
                        </Button>
                        <Button
                            variant="outlined"
                            size="large"
                            onClick={() => navigate('/priority-register')}
                            sx={{ px: 4 }}
                        >
                            Đăng Ký Trực Tiếp
                        </Button>
                    </Box>
                </Paper>
            </Container>

            {/* Footer */}
            <Box
                component="footer"
                sx={{
                    py: 3,
                    textAlign: 'center',
                }}
            >
                <Typography variant="body2" color="text.secondary">
                    © Dai Minh Phat
                </Typography>
            </Box>
        </Box>
    );
};

export default HomePage;
